import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import { withRouter } from "react-router";
import { withStyles } from "@material-ui/core/styles";

import { Typography, CssBaseline } from "@material-ui/core";

import Player from "./components/player";
import School from "./components/school";
import "./App.css";
import Navbar from "./components/Navbar";
import Record from "./components/record";
import Tournament from "./components/tournament";
import History from "./components/history";
import QuestionSet from "./components/questionset";
import Home from "./components/Home";
import Year from "./components/year";

const styles = theme => ({
  root: {
    display: "flex"
  },
  toolbar: {
    paddingRight: 24
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36
  },
  menuButtonHidden: {
    display: "none"
  },
  title: {
    flexGrow: 1
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    height: "100vh",
    overflow: "auto"
  }
});

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true
    };
  }

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <CssBaseline />
        <div className={classes.root}>
          <Navbar></Navbar>
          <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            <Typography component="div" className={classes.chartContainer}>
              <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path="/player/:id" component={Player} />
                <Route
                  exact
                  path="/player/:id/history"
                  render={props => <History {...props} type="Player" />}
                />
                <Route exact path="/school/:id" component={School} />
                <Route
                  path="/player/:id/history/player/:opponentId"
                  render={props => (
                    <History {...props} type="Player" opponentType="Player" />
                  )}
                />
                <Route
                  path="/player/:id/history/school/:opponentId"
                  render={props => (
                    <History {...props} type="Player" opponentType="School" />
                  )}
                />
                <Route
                  path="/school/:id/history/player/:opponentId"
                  render={props => (
                    <History {...props} type="School" opponentType="Player" />
                  )}
                />
                <Route
                  path="/school/:id/history/school/:opponentId"
                  render={props => (
                    <History {...props} type="School" opponentType="School" />
                  )}
                />
                <Route path="/tournament/:id" component={Tournament} />
                <Route path="/questionset/:id" component={QuestionSet} />
                <Route path="/record" component={Record} />
                <Route path="/year/:year" component={Year} />
              </Switch>
            </Typography>
          </main>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(withStyles(styles)(App));
